// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, TableCell, TableRow, TextField } from '@mui/material'
import sortBy from 'lodash/sortBy'
import React from 'react'
import { i18n } from '../../../index'
import css from './wastageBoundary.css'
import type { WastageBoundaryItem } from './wastageBoundary.types'

class WastageBoundaryRows extends React.Component<any, any> {
  state = {
    updateField: {},
    editRowId: '',
    rowIsEditable: false,
  }
  _createControlButton = (text: string, callback: (...args: Array<any>) => any) => (
    <Button variant='contained' color='primary' onClick={callback}>
      {text}
    </Button>
  )
  _onSaveInitial = (rowId: string, id: string, row: WastageBoundaryItem) => {
    this.setState({
      editRowId: rowId,
      updateField: {
        stationId: this.props.stationId,
        id,
        data: { ...row },
      },
    })
  }
  _clearOnEdit = () => {
    this.setState(
      (ps) => ({
        updateField: {},
        editRowId: '',
        rowIsEditable: false,
      }),
      () => this.toggleRowEdit(),
    )
  }
  onRowChange = (e: any, productType: string) => {
    const { name, value } = e.target
    this.setState((ps) => ({
      ...ps,
      updateField: {
        ...ps.updateField,
        data: { ...ps.updateField.data, [name]: value },
      },
    }))
  }
  onRowEdit = (rowId: string, id: string, row: WastageBoundaryItem) => {
    const editable = this.rowCanEdit(rowId)

    if (!editable) {
      this._onSaveInitial(rowId, id, row)
    }

    this.toggleRowEdit()
  }
  toggleRowEdit = () => {
    this.setState((ps) => ({
      rowIsEditable: !ps.rowIsEditing,
    }))
  }
  rowCanEdit = (rowId: string) => rowId === this.state.editRowId && this.state.rowIsEditable
  cancelEditing = () => {
    this.props.refetch().then(() => {
      this._clearOnEdit()
    })
  }
  saveRow = () => {
    const { stationId, id, data } = this.state.updateField
    this.props
      .onMutation({
        variables: {
          stationId,
          id,
          data: {
            ...data,
            upperWastageBounds: +data.upperWastageBounds,
            lowerWastageBounds: +data.lowerWastageBounds,
          },
        },
      })
      .then(() => {
        this.cancelEditing()
      })
  }
  renderRowControls = (rowId: string, id: string, row: WastageBoundaryItem) => {
    return this.rowCanEdit(rowId) ? (
      <React.Fragment>
        {this._createControlButton(i18n.t('buttons.save'), this.saveRow)}
        {this._createControlButton(i18n.t('buttons.cancel'), this.cancelEditing)}
      </React.Fragment>
    ) : (
      this._createControlButton(i18n.t('buttons.edit'), () => this.onRowEdit(rowId, id, row))
    )
  }

  render() {
    const { data } = this.props
    return sortBy(data, (i) => i.productType).map(
      ({ productType, lowerWastageBounds, upperWastageBounds, id }, index) => {
        const rowId = `${index}-${productType}`
        return (
          <TableRow key={productType}>
            <TableCell>
              <span className={css['product-type']}>{i18n.t(`reporting.${productType}`)}</span>
            </TableCell>
            <TableCell>
              <TextField
                disabled={!this.rowCanEdit(rowId)}
                type='number'
                name='lowerWastageBounds'
                defaultValue={lowerWastageBounds}
                onChange={(e) => this.onRowChange(e, productType)}
              />
            </TableCell>
            <TableCell>
              <TextField
                disabled={!this.rowCanEdit(rowId)}
                type='number'
                name='upperWastageBounds'
                defaultValue={upperWastageBounds}
                onChange={(e) => this.onRowChange(e, productType)}
              />
            </TableCell>
            <TableCell>
              <div className={css['row-controls']}>
                {this.renderRowControls(rowId, id, {
                  productType,
                  lowerWastageBounds,
                  upperWastageBounds,
                })}
              </div>
            </TableCell>
          </TableRow>
        )
      },
    )
  }
}

export default WastageBoundaryRows
